<div class="ingreso-page fade-in">
    <div class="ingreso-panel view-container">
        <header class="ingreso-header">
            <img src="assets/logo_corecredit_2.png" alt="Corecredit" class="ingreso-logo" width="160" height="40"
                loading="eager" />
            <h1 id="ingreso-title" class="view-title">Accede a tu portal</h1>
            <p class="view-subtitle ingreso-lead">
                Ingresa tu documento para validar tu identidad y continuar de forma segura.
            </p>
        </header>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="ingreso-form" novalidate>
            <div class="section-group inputs-group">
                <div class="grid grid-cols-1 w-full mb-4 ingreso-fields-stack">
                    <app-core-select label="Tipo de documento" [options]="docTypes" placeholder="Selecciona..."
                        formControlName="document_type_id"
                        [errorMessages]="{ required: 'Campo obligatorio' }">
                    </app-core-select>

                    <app-core-input label="Número de documento" formControlName="document" [maxlength]="12"
                        [restrictionPattern]="'[^0-9]'"
                        [errorMessages]="{
                            required: 'Ingresa tu número de documento',
                            pattern: 'Solo se permiten números',
                            maxlength: 'Máximo 12 dígitos'
                        }"
                        helperText="Sin puntos ni espacios.">
                    </app-core-input>
                </div>
            </div>

            @if (errorMessage) {
                <div class="error-banner" role="alert">
                    <fa-icon [icon]="icons.fasCircleExclamation" class="error-banner__icon" aria-hidden="true" />
                    <span>{{ errorMessage }}</span>
                </div>
            }

            <div class="actions-group text-right">
                <app-core-button label="Continuar" type="submit" [disabled]="form.invalid || isLoading"
                    [isLoading]="isLoading">
                </app-core-button>
            </div>

            <div class="ingreso-secondary">
                <a href="mailto:servicioalcliente@corecredit.co" class="link-help">
                    ¿Necesitas ayuda?
                </a>
            </div>
        </form>
    </div>
</div>
